/**
 * Utility functions for safe formatting of dates and numbers
 */

/**
 * Safely format a date, handling various formats and invalid dates
 */
export function formatDate(date: string | Date | undefined | null): string {
  if (!date) return '-';
  
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    if (isNaN(dateObj.getTime())) {
      return '-';
    }
    
    return dateObj.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  } catch (error) {
    return '-';
  }
}

/**
 * Safely format a date with time
 */
export function formatDateTime(date: string | Date | undefined | null): string {
  if (!date) return '-';
  
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    if (isNaN(dateObj.getTime())) {
      return '-';
    }
    
    return dateObj.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  } catch (error) {
    return '-';
  }
}

/**
 * Safely parse a number, handling strings and invalid values
 */
export function safeParseNumber(value: any, defaultValue: number = 0): number {
  if (typeof value === 'number') {
    return isNaN(value) ? defaultValue : value;
  }
  
  if (typeof value === 'string') {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? defaultValue : parsed;
  }
  
  return defaultValue;
}

/**
 * Safely get a date field from an object, checking multiple possible field names
 */
export function getDateField(obj: any): string | Date | null {
  return obj?.createdAt || obj?.created_at || obj?.updatedAt || obj?.updated_at || null;
}
